import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Navbar = ({ activeSection, onSectionChange }) => {
  const [isPhone, setIsPhone] = useState(window.innerWidth < 768);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsPhone(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleOnlineMagazaClick = () => {
    onSectionChange('online-magaza');
    navigate('/online-magaza');
  };

  const handleMenuClick = () => {
    onSectionChange('menu');
    navigate('/');
  };

  return (
    <nav style={{
      width: '100%',
      height: '40px',
      background: '#f2f2f2',
      display: 'flex',
      alignItems: 'center',
      padding: '0 2rem'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '2rem'
      }}>
        <span 
          onClick={handleMenuClick}
          style={{
            fontWeight: activeSection === 'menu' ? '600' : '200',
            fontFamily: '"Libre Franklin", Arial, sans-serif',
            cursor: 'pointer',
            color: activeSection === 'menu' ? '#8B4513' : '#333',
            transition: 'all 0.3s ease'
          }}
        >
          Menü
        </span>
        <span 
          onClick={handleOnlineMagazaClick}
          style={{
            fontWeight: activeSection === 'online-magaza' ? '600' : '200',
            fontFamily: '"Libre Franklin", Arial, sans-serif',
            cursor: 'pointer',
            marginLeft: '24px',
            color: activeSection === 'online-magaza' ? '#8B4513' : '#333',
            transition: 'all 0.3s ease'
          }}
        >
          Online Mağaza
        </span>
      </div>
    </nav>
  );
};

export default Navbar; 